<div *ngIf="!!errorMessage && !!testId" [attr.test-id]="testId" [innerHtml]="errorMessage"></div>
